<template>
    <section class="max-w-screen-xl mx-auto px-4 lg:px-6 py-8 lg:py-16 rounded-xl my-8 relative">
        <div class="max-w-screen-md mx-auto">
            <p class="uppercase mb-4 text-center">Témoignages</p>
            <TitleH2 class="text-3xl lg:text-4xl text-center"
                titleText="Ils nous font confiance et recommandent nos produits" </TitleH2>
        </div>


        <div class="my-16 lg:my-28"></div>

        <!-- Vidéo témoignage -->
        <!--<div class="w-full max-w-4xl mx-auto mb-16 lg:mb-28">
            <video ref="testimonyVideo" autoplay muted loop controls class="w-full h-auto rounded-lg shadow-lg"
                @loadeddata="handleVideoIntersection">
                <source :src="require('@/assets/videos/interview.mp4')" type="video/mp4">
                Votre navigateur ne supporte pas la lecture vidéo.
            </video>
        </div>-->

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <BentoTestimonial v-for="(testimonial, index) in visibleTestimonials" :key="index"
                :description="testimonial.description" :image="testimonial.image" :identity="testimonial.identity"
                :date="testimonial.date" :note="testimonial.note" :badge="testimonial.badge"
                :visitedDate="testimonial.visitedDate"></BentoTestimonial>
        </div>

        <div v-if="hasMoreTestimonials"
            class="bg-gradient-to-b from-transparent to-linen h-80 md:h-20 lg:h-64 w-full absolute bottom-8 md:bottom-16 lg:bottom-0 backdrop-blur-sm flex items-center justify-center">
            <div>
                <Button textButton="Lire plus d'avis" dark @click="loadMoreTestimonials"></Button>
            </div>
        </div>
    </section>
</template>


<script>
import TitleH2 from '@/Components/Typography/Headings/TitleH2.vue';
import Button from '@/Components/Buttons/Button.vue';
import BentoTestimonial from '@/Components/Bento/Testimonial.vue'

export default {
    name: 'Testimonial',
    components: {
        TitleH2,
        Button,
        BentoTestimonial
    },
    data() {
        return {
            initialTestimonialsCount: 6,
            loadMoreCount: 3,
            currentTestimonialsCount: 6,
            testimonials: [
                {
                    description: "Nous avons fait imprimer des tote bags pour notre entreprise. La communication a été très rapide et réactive, nous avons été très bien conseillés et le projet a été réalisé en un temps record. Nous sommes entièrement satisfaits – à recommander sans hésiter !",
                    image: null,
                    identity: "Josefine Fulde",
                    date: "il y a 3 mois",
                    note: 5,
                    badge: "Local Guide · 11 avis · 9 photos",
                    visitedDate: "Visité en août"
                },
                {
                    description: "Nous avons fait produire des vestes upcyclées sur-mesure à partir d'anciennes bâches publicitaires Back Market en un temps record grâce à Florian. Une superbe réactivité, une excellente communication et un résultat au-dessus de nos attentes. Merci encore pour tout!",
                    image: null,
                    identity: "Marlene JURCEVIC",
                    date: "il y a 3 mois",
                    note: 5,
                    badge: "1 avis",
                    visitedDate: "Visité en septembre"
                },
                {
                    description: "Super expérience avec Flo de chez Jatago! Réactif rapide et efficace, on a eu nos produits de qualité dans les délais annoncés, avec un suivi permanent! On reviendra!",
                    image: null,
                    identity: "Martin Agniel",
                    date: "il y a un an",
                    note: 5,
                    badge: "7 avis",
                    visitedDate: "Visité en juin 2024"
                },
                {
                    description: "Florian de chez Jatago a fait un travail exceptionnel sur l'impression de nos 100 T-shirts personnalisés. Qualité impeccable, respect des délais, et communication fluide. Je recommande vivement ses services !",
                    image: null,
                    identity: "Thomas T",
                    date: "il y a un an",
                    note: 5,
                    badge: "Local Guide · 46 avis · 2 photos",
                    visitedDate: "Visité en août 2024"
                },
                {
                    description: "Une équipe dynamique et professionnelle, qui trouve toujours une solution. Merci à la team Forevents c'est toujours un plaisir d'échanger avec vous et de porter notre collection de vêtements faites sur mesure... C'est une chance de vous avoir comme partenaire de notre projet voile aux côtés de Max depuis plus de 4 ans maintenant...",
                    image: null,
                    identity: "Latitude35 Racing",
                    date: "il y a 2 ans",
                    note: 5,
                    badge: "2 avis",
                    visitedDate: "Visité en janvier 2023"
                },
                {
                    description: "Une confiance absolue et une disponibilité des équipes. Bientôt 9 ans que je collabore avec les équipes de Forevents pour l'accompagnement de mes projets textiles. Un suivi personnalisé et des échanges fluides avec les différents pôles. Je recommande les yeux fermés",
                    image: null,
                    identity: "Maxime Rabouan",
                    date: "il y a 2 ans",
                    note: 5,
                    badge: "1 avis",
                    visitedDate: "Visité en janvier 2023"
                },
                {
                    description: "Une équipe réactive et riche de plein de conseils et des produits de qualité qu'on aime porter tous les jours ! Déjà client Forevents depuis 2016, je continue de leur confier tous les projets textile de mes différents projets les yeux fermés",
                    image: null,
                    identity: "Julien Sarton",
                    date: "il y a 3 ans",
                    note: 5,
                    badge: "Local Guide · 92 avis · 41 photos",
                    visitedDate: "Visité en octobre 2022"
                },
                {
                    description: "Les équipes Forevents m'accompagnent depuis 3 ans sur tous mes projets textiles. Ils ont su monter avec moi sur des projets très différents et me proposer de nouvelles techniques d'impressions. Force de propositions et surtout de solutions",
                    image: null,
                    identity: "Sev M.",
                    date: "il y a 6 ans",
                    note: 5,
                    badge: "Local Guide · 16 avis",
                    visitedDate: "Visité en décembre 2019"
                },
                {
                    description: "Merci à toute l'équipe pour votre soutien, vos conseils, votre réactivité et surtout pour la qualité des produits. La collection capsule que nous avons créé ensemble pour le Bon Marché dans le cadre du dispositif \"Drive me Crazy - Porsche X TAG\" fût un succès !",
                    image: null,
                    identity: "Charles Dubois",
                    date: "il y a 3 ans",
                    note: 5,
                    badge: "7 avis",
                    visitedDate: "Visité en avril 2022"
                },
                {
                    description: "Très bon service. Très à l'écoute des clients",
                    image: null,
                    identity: "Philippe Caumes",
                    date: "il y a 6 mois",
                    note: 5,
                    badge: "4 avis",
                    visitedDate: "Visité en mai"
                },
                {
                    description: "Travaillant avec les équipes de Forevents depuis maintenant plus de 2 ans, je ne peux que recommander les service qu'ils proposent.",
                    image: null,
                    identity: "Charles Degenne",
                    date: "il y a 5 ans",
                    note: 5,
                    badge: "Local Guide · 10 avis · 26 photos",
                    visitedDate: "Visité en mai 2020"
                },
                {
                    description: "Les produits sont de qualités et l'équipe est réactive, à l'écoute et disponible! Je recommande les yeux fermés! Et livraison rapide! Encore merci Forevents!",
                    image: null,
                    identity: "Elodie Caillaud",
                    date: "il y a 5 ans",
                    note: 5,
                    badge: "2 avis",
                    visitedDate: "Visité en juillet 2020"
                },
                {
                    description: "J'ai eu l'occasion de travailler avec Forevents sur plusieurs projets et je dois dire que je n'ai pas été déçu de la réactivité, prix et qualité. Je recommande fortement !",
                    image: null,
                    identity: "Nicolas",
                    date: "il y a 5 ans",
                    note: 5,
                    badge: "Local Guide · 25 avis · 13 photos",
                    visitedDate: "Visité en juin 2020"
                },
                {
                    description: "Nous sommes hyper content !!! Nous commandons régulièrement chez Forevents et à chaque fois la qualité est au rendez vous ! Bref on recommande à fond.",
                    image: null,
                    identity: "Armel",
                    date: "il y a 5 ans",
                    note: 5,
                    badge: "Local Guide · 41 avis · 7 photos",
                    visitedDate: "Visité en juin 2020"
                },
                {
                    description: "Forevents a réalisé des Polos brodés pour notre équipe. La qualité du produit n'a d'égal que la réactivité de leur équipe",
                    image: null,
                    identity: "Bouches B.",
                    date: "il y a 6 ans",
                    note: 5,
                    badge: "3 avis · 11 photos",
                    visitedDate: null
                },
                {
                    description: "J'ai pu passer commande de sweat et mug pour notre société. Respect du délai de livraison et produit conforme à la commande. Je recommande fortement Forevents aux sociétés ayant des besoins de textile de qualité.",
                    image: null,
                    identity: "Vladimir Zlatiev",
                    date: "il y a 6 ans",
                    note: 5,
                    badge: "Local Guide · 8 avis · 42 photos",
                    visitedDate: null
                },
                {
                    description: "Déjà plusieurs commandes que je fais pour mon travail et je suis toujours aussi satisfaite. Ils ont le sens de qualité. Je recommande",
                    image: null,
                    identity: "Marylise P",
                    date: "Modifié il y a 6 mois",
                    note: 5,
                    badge: "Local Guide · 44 avis · 2 photos",
                    visitedDate: "Visité en mai"
                }
            ],
            isMobile: false,
        };
    },
    mounted() {
        this.checkIfMobile();
        this.setupVideoIntersectionObserver();
    },

    computed: {
        visibleTestimonials() {
            if (this.isMobile) {
                return this.testimonials.slice(0, this.currentTestimonialsCount);
            } else {
                return this.testimonials.slice(0, this.currentTestimonialsCount);
            }
        },
        hasMoreTestimonials() {
            return this.currentTestimonialsCount < this.testimonials.length;
        }
    },

    methods: {
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 768; // Adjust 768 as per your mobile breakpoint
            if (this.isMobile) {
                this.currentTestimonialsCount = 3;
            }
        },
        loadMoreTestimonials() {
            console.log('a');
            this.currentTestimonialsCount = Math.min(this.currentTestimonialsCount + this.loadMoreCount, this.testimonials.length);
        },
        setupVideoIntersectionObserver() {
            if (this.$refs.testimonyVideo) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.play();
                        } else {
                            entry.target.pause();
                        }
                    });
                }, {
                    threshold: 0.5 // La vidéo se lance quand 50% est visible
                });

                observer.observe(this.$refs.testimonyVideo);
            }
        },
        handleVideoIntersection() {
            // Cette méthode est appelée quand la vidéo est chargée
            this.setupVideoIntersectionObserver();
        }
    }
}
</script>